import {
  Field,
  InputType,
  registerEnumType,
} from '@warebee/shared/util-backend-only-types';

@InputType({
  description: `Pagination specification with 'skip' and 'limit' values`,
})
export class SkipLimitPageSpec {
  @Field({ nullable: true, description: `Number of objects to skip` })
  skip?: number;

  @Field({ nullable: true, description: `Max number of objects to retrieve` })
  limit?: number;
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

registerEnumType(SortDirection, {
  name: 'SortDirection',
  description: `Sorting direction`,
});
